export default function legacyIsDesktop () {
  let chk = false;

  if (window.innerWidth < 642) {
    chk = false;
  } else {
    chk = true;
  }

  return chk;
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/legacyIsDesktop.js